import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.splice.js";
import serverList from "../../../components/serverList/serverOptions.vue";
import PayOptions from "../../../components/serverList/payOptions.vue";
import { getPayMap as _getPayMap } from "@/utils/dictionary";
//填写申请充值信息
// import { checkRole } from "@/api/data";
import { savePayRequest } from "@/api/payItem";
export default {
  name: "sendRecRequest",
  components: {
    serverList: serverList,
    PayOptions: PayOptions
  },
  data: function data() {
    return {
      form: {},
      isEditPage: false,
      //选择框选择玩家的类型
      selValue: "",
      options: [{
        value: "1",
        label: "玩家ID"
      }
      // {
      //     value: "2",
      //     label: "玩家昵称",
      // },
      ],

      //子组件返回的是否填写完了邮件信息
      isfillEmail: false,
      //将父组件的值传自己再传子组件
      writeEmailType: 0,
      //减少一行物品配置按钮
      coinReduceBtn: false,
      payArray: []
    };
  },
  created: function created() {
    this.getPayMap();
  },
  methods: {
    getPayMap: function getPayMap() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, index;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _getPayMap();
            case 2:
              res = _context.sent;
              for (index in res) {
                _this.payArray.push({
                  pay_id: index,
                  pay_name: res[index]
                });
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    init: function init(e) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.form = JSON.parse(JSON.stringify(e.formInfo));
              _this2.isEditPage = JSON.parse(JSON.stringify(e.isEditPage));
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    //新增一个个充值配置
    addPayMsg: function addPayMsg() {
      this.form.role_list.push({
        server_id: "",
        role_id: ""
      });
      this.coinReduceBtn = true;
    },
    //减少一个个物品配置，第一个减号不能点击
    reducePayMsg: function reducePayMsg(index) {
      for (var i = 1; i < this.form.role_list.length; i++) {
        if (index === i) {
          this.form.role_list.splice(i, 1);
        }
      }
    },
    checkPay: function checkPay() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res, data;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(_this3.form.pay_item_id && _this3.form.pay_item_id.length)) {
                _context3.next = 7;
                break;
              }
              _context3.next = 3;
              return savePayRequest(_this3.form);
            case 3:
              res = _context3.sent;
              if (res.code == 0) {
                _this3.$message({
                  message: "恭喜你，发送充值申请成功",
                  type: "success"
                });
                data = {
                  dialogFormVisible: false
                };
                _this3.$emit("backPersonEmail", data);
              }
              _context3.next = 8;
              break;
            case 7:
              _this3.$message({
                message: "请选择充值配置",
                type: "error"
              });
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    }
  }
};